export default "__VITE_ASSET__D$vlKWHZ__"